import React from 'react'
import { CompDiaria, CompMensalista, CompPedido } from '../../../Complex'
import { IoChevronBackOutline } from 'react-icons/io5'
import { Loading, SearchAlert } from '../../../Simple'
import { AgendamentoContext } from '../../../../contexts/AgendamentoContext'
import { Box, Typography } from '@mui/material'
import RouterHook from '../../../../contexts/RouterHook'
import BttAgend from './BttAgend'
import BttIcone from './BttIcone'

import { stDesk } from '../styles'
import './stylesAgnd.css'

export default function DesktopAU() {
  const serverRouter = RouterHook()

  const { sttCtxAgend, actionsAgend, loadAgend } = React.useContext(AgendamentoContext)

  const containListRef = React.useRef(null)

  const bttAgendaTopo = ['Horários Avulsos', 'Horários Fixos', 'Diárias']

  const tiposPedido = ['Mostrar todos', 'Apenas avulsos', 'De horários fixos']

  const modPedidos = [{ text: 'Solicitados' }, { text: 'Agendados' }, { text: 'Realizados' }, { text: 'Cancelados' }, { text: 'Todos' }]

  React.useEffect(() => {
    if (sttCtxAgend.bttAgSel === 'avulsos') {
      actionsAgend.BuscarAgendamentosAvulsos(true)
    } else if (sttCtxAgend.bttAgSel === 'fixos') {
      actionsAgend.BuscarMensalistasUsuario(true)
    } else if (sttCtxAgend.bttAgSel === 'diarias') {
      actionsAgend.BuscarDiariasUsuario(true)
    }
  }, [sttCtxAgend.bttAgSel, sttCtxAgend.typePed, sttCtxAgend.avulsoSel])

  React.useEffect(() => {
    const handleScroll = () => {
      if (containListRef.current) {
        const { scrollTop, clientHeight, scrollHeight } = containListRef.current
        if (scrollTop + clientHeight >= scrollHeight - 10 && !loadAgend.pagina && !loadAgend.list && sttCtxAgend.offset < sttCtxAgend.maxScroll) {
          if (sttCtxAgend.bttAgSel === 'avulsos') actionsAgend.BuscarAgendamentosAvulsos(false)
          else if (sttCtxAgend.bttAgSel === 'fixos') actionsAgend.BuscarMensalistasUsuario(false)
          else if (sttCtxAgend.bttAgSel === 'diarias') actionsAgend.BuscarDiariasUsuario(false)
        }
      }
    }

    const refCurrent = containListRef.current
    if (refCurrent) {
      refCurrent.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (refCurrent) {
        refCurrent.removeEventListener('scroll', handleScroll)
      }
    }
  }, [containListRef, loadAgend.pagina, loadAgend.list, sttCtxAgend.offset, sttCtxAgend.maxScroll])

  return (
    <Box sx={stDesk.containAgendaUser}>
      <Box sx={stDesk.containTitle}>
        <IoChevronBackOutline style={stDesk.iconBack} onClick={() => serverRouter('back')} />
        <Typography variant='h5' sx={stDesk.titlePage}>
          Minha Agenda
        </Typography>
      </Box>
      <Box sx={stDesk.containAgenda}>
        <div className='contain-btts-agenda-topo-a'>
          {/* Grade de botões para configurar horário fixo! */}
          {bttAgendaTopo.map((item, index) => {
            return <BttAgend key={index} item={item} index={index} mode={true} />
          })}
        </div>
        {sttCtxAgend.bttAgSel === 'avulsos' && (
          <div className='contain-btts-agenda-topo' style={{ marginTop: '5px' }}>
            {tiposPedido.map((item, index) => (
              <BttAgend key={index} item={item} index={index} mode={false} />
            ))}
          </div>
        )}
        {sttCtxAgend.bttAgSel === 'avulsos' && (
          <div className='contain-btts-list-pedidos'>
            {modPedidos.map((item, index) => {
              return <BttIcone key={index} text={item.text} idx={index} />
            })}
          </div>
        )}
        <Box sx={stDesk.containListItens} ref={containListRef}>
          {/* Lista de pedidos */}
          {loadAgend.list ? (
            <div className='contain-loading'>
              <Loading text={'Carregando...'} />
            </div>
          ) : sttCtxAgend.bttAgSel === 'avulsos' ? (
            sttCtxAgend.avulsos.length > 0 ? (
              sttCtxAgend.avulsos.map((item, index) => (
                <React.Fragment key={index}>
                  <CompPedido pedido={item} />
                </React.Fragment>
              ))
            ) : (
              <SearchAlert text={'Não encontramos agendamentos'} />
            )
          ) : sttCtxAgend.bttAgSel === 'fixos' ? (
            sttCtxAgend.fixos.length > 0 ? (
              sttCtxAgend.fixos.map((item, index) => (
                <React.Fragment key={index}>
                  <CompMensalista mens={item} />
                </React.Fragment>
              ))
            ) : (
              <SearchAlert text={'Não encontramos agendamentos'} />
            )
          ) : sttCtxAgend.bttAgSel === 'diarias' && sttCtxAgend.diarias.length > 0 ? (
            sttCtxAgend.diarias.map((item, index) => (
              <React.Fragment key={index}>
                <CompDiaria diaria={item} mode={true} />
              </React.Fragment>
            ))
          ) : (
            <SearchAlert text={'Não encontramos agendamentos'} />
          )}
          {!loadAgend.list && loadAgend.pagina && (
            <div className='contain-loading'>
              <Loading />
            </div>
          )}
        </Box>
      </Box>
    </Box>
  )
}
